import React from 'react';
import {FormattedMessage} from 'react-intl';

import {UserManualTypes, UserManualType} from 'pages/System/UserManual/types';

interface UserManualLabelInterface {
    type: UserManualType;
}

const UserManualLabel: React.FC<UserManualLabelInterface> = ({type}) => {
    switch (type) {
        case UserManualTypes.Student:
            return <FormattedMessage id='system.student_manual'/>

        case UserManualTypes.Supervision:
            return <FormattedMessage id='system.supervision_manual'/>

        case UserManualTypes.Lector:
            return <FormattedMessage id='system.lector_manual'/>

        default:
            return <></>
    }
}

export default UserManualLabel;